import './learn.css';

import React, { Component } from 'react';
import { Link } from 'react-router';
import Icon from '../components/Icon';

import { MEDIA_URI } from '../services/config';
import lang, { selectedLocalization } from '../services/lang';
import { chapters } from '../services/content';
import introUrl from '../images/wakelee.jpg';
import { beep } from '../services/audio';
import { trackView } from '../services/analytics';

export default class Learn extends Component {
  componentDidMount() {
    beep();
    trackView("Learn");
  }
  
  renderChapter = (chapter, index) => {
    const photo = `${MEDIA_URI}/${chapter.photo.path}${chapter.photo.filename}`;
    const title = chapter['title_'+selectedLocalization] || chapter.title;
    
    return (
      <Link to={`/chapters/${index}`} key={chapter._id} className="learn-chapter">
        <div className="learn-chapter-inner">
          <div 
            className="learn-chapter-photo"
            style={{backgroundImage: `url(${photo})`}}
          />
          <div className="learn-chapter-info">
            {title}
          </div>
        </div>
      </Link>
    );
  }
  
  render() {
    return (
      <div className="learn">
        <div className="learn-content">
          <h1 className="learn-title">{lang('learn-about-clinical-trials')}</h1>
          <div className="learn-chapters-wrapper">
            <div className="learn-chapters">
            
              <Link to="/welcome" className="learn-chapter">
                <div className="learn-chapter-inner">
                  <div 
                    className="learn-chapter-photo"
                    style={{backgroundImage: `url(${introUrl})`}}
                  />
                  <div className="learn-chapter-info">
                    {lang('learn-about-clinical-trials')}
                  </div>
                </div>
              </Link>
              
              {chapters.map(this.renderChapter)}

            </div>
          </div>
        </div>
        <div className="learn-menu-row">
          <div className="learn-menu">
            <h5 className="learn-menu-subtitle">{lang('learn-about-clinical-trials')}</h5>
            <Link to="/menu" className="learn-menu-main">
              {lang('main-menu')} <Icon name="menuWhite" className="learn-menu-main-icon"/>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Learn.js